import { Vehicle } from '@apis/index'
import { eye, totalBus } from '@assets/icons'
import Table from '@components/table'
import { RootState } from '@store/index'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'

const Vehicles = ({ user, dashboard }) => {
  const navigate = useNavigate()
  const { state: providerId } = useLocation()
  const {
    items: vehicles,
    totalItems,
    totalPages,
    loading,
  } = useSelector((state: RootState) => state.vehicles)
  const [page, setPage] = useState(1)
  const fetchVehicle = async () => {
    await Vehicle.list({
      state: 'vehicles',
      params: { createdBy: user.id, page, limit: 20 },
    })
      .then(() => {})
      .catch(() => {})
  }
  const columns = [
    {
      title: 'Vehicle Name',
      key: '',
      render: (item) => (
        <>
          <p>{item.name}</p>
          <p>{item.number}</p>
        </>
      ),
    },
    { title: 'Vehicle Type', key: '', render: (item) => item?.type },
    { title: 'Vehicle Layout', key: '', render: (item) => item?.layout?.name },
    { title: 'Trips Made', key: '', render: (item) => <>N/A</> },
    { title: 'Amenities', key: '', render: (item) => item?.amenities?.length },
    {
      title: 'Vehicle Status',
      key: '',
      render: (item) => (item.status ? 'Available' : 'Unavailable'),
    },
  ]

  useEffect(() => {
    if (user?.id || providerId) fetchVehicle()
  }, [user?.id, page, providerId])
  return (
    <Table
      text="Vehicles"
      icon={totalBus}
      columns={columns}
      data={vehicles}
      itemsPerPage={20}
      totalItems={totalItems}
      totalPages={totalPages}
      pageControlled={page}
      loading={loading}
      onPageChange={setPage}
      onRowClick={(row) =>
        navigate(
          `/admin/user-management/providers/${user?.id}/vehicle/${row?.id}`,
          {
            state: {
              vehicleId: row?.id,
              providerId: user?.id,
              user: user,
              dashboard,
            },
          },
        )
      }
      actions={[
        {
          key: 'view',
          icon: eye,
          onClick: (row) => {
            navigate(
              `/admin/user-management/providers/${user.id}/vehicle/${row.id}`,
              { state: { vehicleId: row.id, providerId: user.id, user: user } },
            )
          },
        },
      ]}
    />
  )
}

export default Vehicles
